module.exports = __webpack_public_path__ + "static/media/type_c.d2fde284.png";